import api from 'api';
import ApiService from 'api/ApiService';
import Token from 'api/Token';
import {XCSRF_TOKEN_HEADER} from 'common/constants';

let csrfRefreshPromise: Promise<string> | null = null;

const fetchCsrfToken = (url: string = api.connect) => {
   return ApiService.getOrigin(url, {[XCSRF_TOKEN_HEADER]: 'Fetch'}).catch((res) => {
      console.debug('csrf error', res);
      const csrfToken = res.headers?.get(XCSRF_TOKEN_HEADER);
      return csrfToken;
   });
};

export const refreshCsrfOnce = (): Promise<string> => {
   if (!csrfRefreshPromise) {
      csrfRefreshPromise = fetchCsrfToken()
         .then((token) => {
            Token.setCsrfToken(token);
            return token;
         })
         .finally(() => {
            csrfRefreshPromise = null;
         });
   }

   return csrfRefreshPromise;
};
